import { NgModule } from "@angular/core";

import { IsAppDirective } from "./is-app.directive";

@NgModule({
	declarations: [IsAppDirective],
	exports: [IsAppDirective],
})
export class CoreDirectivesModule {}
